import React from 'react';
import { Button } from 'react-bootstrap';
import PESService from 'App/services/PESService';
import { FaDownload } from 'react-icons/fa';
import { file as filePropType } from './proptypes';

const propTypes = {
    file: filePropType.isRequired,
};

const defaultProps = {};

function ClinicalNoteButton({ file }) {
    return (
        <Button
            data-testid="clinical-note-button"
            variant="link"
            onClick={() => {
                PESService.downloadClinicalNote(file.patientId, file);
            }}
        >
            <span className="file-name"> {file.origFileName} </span>
            <span className="file-icon">
                <FaDownload />
            </span>
        </Button>
    );
}

ClinicalNoteButton.propTypes = propTypes;
ClinicalNoteButton.defaultProps = defaultProps;

export default ClinicalNoteButton;
